// ADDENDUM 49 (§5.4) — cuántos días lleva en curso una operación de una pieza.
//
// ⚠️⚠️ ES EL ÚNICO DATO DE ESTA PANTALLA QUE NO VIENE DE SUN, y por eso vive aparte y se prueba
// solo: se deriva de `hoy − inicio`. Un derivado del reloj tiene dos trampas que un dato servido
// no tiene, y las dos están cubiertas abajo.
//
// 📌 CUENTA DÍAS ENTEROS TRANSCURRIDOS, no diferencias de calendario. `83 días` significa que han
// pasado 83×24 horas, no que el calendario haya cambiado 83 veces. La distinción importa con los
// cambios de hora: un 30 de marzo dura 23 horas, y contar "cambios de fecha" haría que el número
// saltara a medianoche para todo el mundo a la vez aunque nadie hubiera trabajado.
//
// ⚠️ Y NO SE REDONDEA HACIA ARRIBA. Con `Math.ceil`, una operación arrancada hace diez minutos
// diría "1 día en curso", que es falso y además alarmante: el número está pintado en ámbar. Se
// trunca, así que las primeras 24 horas son `0`, y quien pinta decide si un cero merece escribirse.
const asTime = (value) => {
  if (value === null || value === undefined || value === '') return null
  const parsed = Date.parse(value)
  return Number.isNaN(parsed) ? null : parsed
}

const MS_POR_DIA = 24 * 60 * 60 * 1000

/**
 * @param {string|null} startDate el arranque, tal cual lo sirve Sun
 * @param {Date|number} [now] el ahora — inyectable A PROPÓSITO: sin esto el test tendría que
 *   congelar el reloj global o comparar contra un número que cambia cada día que pasa, y un test
 *   que depende del calendario falla solo un martes cualquiera sin que nadie lo haya tocado.
 * @returns {number|null} días enteros transcurridos, o `null` si no se puede calcular — que NO es
 *   cero: "no sé cuándo empezó" y "empezó hace menos de un día" son dos hechos distintos (RN8).
 */
export const daysInProgress = (startDate, now = Date.now()) => {
  const start = asTime(startDate)
  if (start === null) return null
  const ahora = now instanceof Date ? now.getTime() : now
  if (!Number.isFinite(ahora)) return null
  // ⚠️ Un inicio EN EL FUTURO no da días negativos: da 0. Ocurre con relojes desajustados entre
  // la máquina de planta y el servidor, y "−2 días en curso" es peor que no decir nada.
  return Math.max(0, Math.floor((ahora - start) / MS_POR_DIA))
}
